import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalConfig } from '../models/modalConfig';
import { UploadReqTransactionCandidatesModalComponent } from 'src/app/pages/mission-control-page/upload-req-page/upload-req-transaction-candidates-modal/upload-req-transaction-candidates-modal.component';

@Injectable({
  providedIn: 'root'
})
export class UploadReqTransactionCandidatesModalService {

  transactionCandidatesModal!: BsModalRef;

  constructor(private bsModalService: BsModalService) { }

  show(jobId: any, jobScore: any, score: any, transactionId: any, countType: any, clientOrBuLabel: any): void {
    const config = new ModalConfig();
    config.class = 'modal-lg four-dot-five-modal-large';
    config.initialState = { jobId, jobScore, score, transactionId, countType, clientOrBuLabel };
    this.transactionCandidatesModal = this.bsModalService.show(UploadReqTransactionCandidatesModalComponent, config);
  }
}
